import React from "react";
import { COMPLETE_STATUSES } from "../lib/onboardingConstants";

export const OnboardingProgress = ({ requirements = [] }) => {
  const total = requirements.length || 1;
  const complete = requirements.filter((r) => COMPLETE_STATUSES.includes(r.status)).length;
  const pct = Math.round((complete / total) * 100);

  return (
    <div data-testid="onboarding-progress">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-semibold text-gray-700">{complete} / {total} complete</span>
        <span className="text-sm font-bold text-blue-600">{pct}%</span>
      </div>
      <div className="w-full h-2.5 rounded-full bg-gray-100 overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-blue-500 to-blue-600 rounded-full transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
};
